module.exports = __webpack_public_path__ + "img/Ford.82f975ff.jpg";